// // PersonalDetailsForm.jsx
// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { getUserWithActiveAddress, updateUserProfile } from "../../State/Auth/Action";

// function PersonalDetailForm() {
//     const dispatch = useDispatch();
//     const jwt = localStorage.getItem("jwt");
//     const role = localStorage.getItem("role");

//     const { auth } = useSelector((store) => store);

//     // Local state for input fields
//     const [formData, setFormData] = useState({
//         name: "",
//         phone: "",
//         email: "",
//     });

//     const [errors, setErrors] = useState({});

//     // Load user data into form when auth changes
//     useEffect(() => {
//         if (jwt && role === "CUSTOMER") {
//             dispatch(getUserWithActiveAddress());
//         }
//     }, [jwt, role, dispatch]);

//     useEffect(() => {
//         if (auth?.user) {
//             setFormData({
//                 name: auth.user.name || "",
//                 phone: auth.user.phone || "",
//                 email: auth.user.email || "",
//             });
//         }
//     }, [auth?.user]);

//     // Handle input change
//     const handleChange = (e) => {
//         // Allow only digits in phone
//         if (e.target.name === "phone" && !/^\d*$/.test(e.target.value)) return;

//         setFormData({
//             ...formData,
//             [e.target.name]: e.target.value,
//         });
//     };

//     // Basic validation
//     const validateForm = () => {
//         let tempErrors = {};
//         if (!formData.name.trim()) tempErrors.name = "Full name is required";
//         if (!formData.phone.trim()) tempErrors.phone = "Phone number is required";
//         else if (!/^\d{10}$/.test(formData.phone))
//             tempErrors.phone = "Phone number must be 10 digits";

//         if (!formData.email.trim()) tempErrors.email = "Email is required";
//         else if (!/^\S+@\S+\.\S+$/.test(formData.email))
//             tempErrors.email = "Invalid email format";

//         setErrors(tempErrors);
//         return Object.keys(tempErrors).length === 0;
//     };

//     // Submit handler
//     const handleSubmit = (e) => {
//         e.preventDefault();

//         if (!validateForm()) return;

//         dispatch(updateUserProfile(auth?.user?.id, formData));
//     };


//     return (
//         <form
//             className="flex flex-col gap-5"
//             aria-labelledby="personal-details-heading"
//             onSubmit={handleSubmit}
//         >
//             {/* Full Name */}
//             <div className="grid gap-2">
//                 <label className="text-xs uppercase tracking-wide text-neutral-700">
//                     Full Name
//                 </label>
//                 <input
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     className="h-10 w-full rounded-none border border-neutral-300 px-3 text-sm text-neutral-800 outline-none focus:border-neutral-500"
//                     placeholder="Enter Your Full Name"
//                 />
//                 {errors.name && <p className="text-red-500 text-xs">{errors.name}</p>}
//             </div>

//             {/* Phone */}
//             <div className="grid gap-2">
//                 <label className="text-xs uppercase tracking-wide text-neutral-700">
//                     Phone Number
//                 </label>
//                 <input
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     maxLength={10} // optional लेकिन उपयोगी है
//                     className="h-10 w-full rounded-none border border-neutral-300 px-3 text-sm text-neutral-800 outline-none focus:border-neutral-500"
//                     placeholder="Enter Your Phone Number"
//                 />
//                 {errors.phone && <p className="text-red-500 text-xs">{errors.phone}</p>}
//             </div>

//             {/* Email */}
//             <div className="grid gap-2">
//                 <label className="text-xs uppercase tracking-wide text-neutral-700">
//                     Email Address
//                 </label>
//                 <input
//                     name="email"
//                     type="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     readOnly   // 👈 Add this
//                     className="h-10 w-full rounded-none border border-neutral-300 px-3 text-sm text-neutral-800 outline-none focus:border-neutral-500 bg-gray-100 cursor-not-allowed"
//                     placeholder="Enter Your Email"
//                 />
//                 {errors.email && <p className="text-red-500 text-xs">{errors.email}</p>}
//             </div>

//             {/* Submit Button */}
//             <div className="pt-2">
//                 <button
//                     type="submit"
//                     disabled={auth?.isLoading}
//                     className="h-11 w-full bg-neutral-900 text-sm font-medium uppercase tracking-wide text-white disabled:opacity-50"
//                 >
//                     {auth?.isLoading ? "Saving..." : "Save Changes"}
//                 </button>
//             </div>
//         </form>
//     );
// }

// export default PersonalDetailForm;

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getUserWithActiveAddress,
    updateUserProfile,
} from "../../State/Auth/Action";
import { InputAdornment, MenuItem, TextField } from "@mui/material";
import countryData from '../../../config/country-phone-code-and-length.json';
import { useConvertPrice } from "../../../Hooks/useConvertPrice";
import { useNavigate } from "react-router-dom";

function PersonalDetailForm() {
    const dispatch = useDispatch();
    const jwt = localStorage.getItem("jwt");
    const role = localStorage.getItem("role");
    const { selectedCountry } = useConvertPrice();
    const navigate = useNavigate();

    const { auth } = useSelector((store) => store);

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
    });

    const [errors, setErrors] = useState({});

    const [initialContact, setInitialContact] = useState({
        hasEmail: false,
        hasPhone: false,
    });

    const [country, setCountry] = useState(countryData.find(c => selectedCountry && c.label.includes(selectedCountry)) ||
        countryData.find(c => c.code === "IN"));
    const [mobile, setMobile] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        if (jwt && role === "CUSTOMER") {
            dispatch(getUserWithActiveAddress());
            setCountry(
                countryData.find(c => selectedCountry && c.label.includes(selectedCountry)) ||
                countryData.find(c => c.code === "IN")
            );
        }
    }, [jwt, role, dispatch, selectedCountry]);

    useEffect(() => {
        if (jwt && role === "CUSTOMER") {
            setCountry(
                countryData.find(c => selectedCountry && c.label.includes(selectedCountry)) ||
                countryData.find(c => c.code === "IN")
            );
        }
    }, [jwt, role, selectedCountry]);

    useEffect(() => {
        if (!auth?.user) return;

        const emailExists = !!auth.user.email?.trim();
        const phoneExists = !!auth.user.phone?.trim();

        setFormData({
            name: auth.user.name || "",
            phone: auth.user.phone || "",
            email: auth.user.email || "",
        });

        if (auth.user.phone) {
            const [code, number] = auth.user.phone.split(" ");
            setMobile(number || "");
            setCountry(
                countryData.find(
                    (c) => c.phone === code?.replace("+", "")
                ) || null
            );
        }

        setInitialContact({
            hasEmail: emailExists,
            hasPhone: phoneExists,
        });
    }, [auth.user]);

    const hasEmail = !!formData.email?.trim();
    const hasPhone = !!formData.phone?.trim() || !!mobile.trim();



    const handleCountryChange = (e) => {
        const selected = countryData.find(c => c.code === e.target.value);
        setCountry(selected);
        // ✅ mobile empty → phone bilkul empty
        const fullNumber =
            mobile && mobile.trim() !== ""
                ? `${selected.phone} ${mobile}`
                : "";
        setFormData((prev) => ({ ...prev, phone: fullNumber }));
        // ✅ Determine required phone length (local number length only)
        let requiredLength = null;

        if (selected && mobile.trim()) {
            if (selected.phoneLength) {
                requiredLength = selected.phoneLength; // number or array
            } else if (selected.min && selected.max) {
                requiredLength = { min: selected.min, max: selected.max };
            }
        }

        // ✅ Validate local number
        let isValid = true;

        if (Array.isArray(requiredLength)) {
            isValid = requiredLength.includes(mobile.length);
        } else if (typeof requiredLength === "number") {
            isValid = mobile.length === requiredLength;
        } else if (requiredLength?.min && requiredLength?.max) {
            isValid = mobile.length >= requiredLength.min && mobile.length <= requiredLength.max;
        }

        if (!isValid) {
            setError(
                `Phone number must be ${Array.isArray(requiredLength)
                    ? requiredLength.join(" or ")
                    : requiredLength?.min
                        ? `${requiredLength.min}-${requiredLength.max}`
                        : requiredLength
                } digits`
            );
        } else {
            setError("");
            // ✅ Send full number to backend
            setFormData((prev) => ({ ...prev, phone: fullNumber }));
        }
    };

    const handlePhoneChange = (e) => {
        // allow only digits for mobile & zipcode
        if (e.target.name === "mobile" && !/^\d*$/.test(e.target.value)) return;
        const cleaned = e.target.value.replace(/\D/g, ""); // ✅ Only digits
        // ✅ Construct full number (+countryCode + localNumber)
        // ✅ mobile empty → phone bilkul empty
        const fullNumber =
            cleaned && cleaned.trim() !== ""
                ? `${country.phone} ${cleaned}`
                : "";
        setMobile(e.target.value);
        // ✅ Determine required phone length (local number length only)
        let requiredLength = null;

        if (country && cleaned.trim()) {
            if (country.phoneLength) {
                requiredLength = country.phoneLength; // number or array
            } else if (country.min && country.max) {
                requiredLength = { min: country.min, max: country.max };
            }
        }

        // ✅ Validate local number
        let isValid = true;

        if (Array.isArray(requiredLength)) {
            isValid = requiredLength.includes(cleaned.length);
        } else if (typeof requiredLength === "number") {
            isValid = cleaned.length === requiredLength;
        } else if (requiredLength?.min && requiredLength?.max) {
            isValid = cleaned.length >= requiredLength.min && cleaned.length <= requiredLength.max;
        }

        if (!isValid) {
            setError(
                `Phone number must be ${Array.isArray(requiredLength)
                    ? requiredLength.join(" or ")
                    : requiredLength?.min
                        ? `${requiredLength.min}-${requiredLength.max}`
                        : requiredLength
                } digits`
            );
        } else {
            setError("");
            // ✅ Send full number to backend
            setFormData((prev) => ({ ...prev, phone: fullNumber }));
        }

    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "phone" && !/^\d*$/.test(value)) return;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validateForm = () => {
        let tempErrors = {};

        if (!formData.name.trim()) {
            tempErrors.name = "Full name is required";
        }

        if (!hasEmail && !hasPhone) {
            tempErrors.email = "Email or Phone number is required";
            tempErrors.phone = "Email or Phone number is required";
        }

        // if (hasPhone && !/^\d{10}$/.test(formData.phone)) {
        //     tempErrors.phone = "Phone number must be 10 digits";
        // }

        if (hasEmail && !/^\S+@\S+\.\S+$/.test(formData.email)) {
            tempErrors.email = "Invalid email format";
        }

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm() || error) return;
        dispatch(updateUserProfile(auth?.user?.id, formData, navigate));
    };

    return (
        <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
            {/* Name */}
            <div className="grid gap-2">
                <label className="text-xs uppercase text-neutral-700">
                    Full Name *
                </label>
                <input
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="h-10 w-full border px-3 text-sm outline-none"
                    placeholder="Enter Full Name"
                />
                {errors.name && (
                    <p className="text-xs text-red-500">{errors.name}</p>
                )}
            </div>

            {/* Phone */}
            <div className="grid gap-2">
                <label className="text-xs uppercase text-neutral-700">
                    Phone Number
                </label>
                <TextField
                    fullWidth
                    value={mobile}
                    onChange={handlePhoneChange}
                    placeholder="Enter mobile number"
                    variant="outlined"
                    size="small"
                    disabled={initialContact.hasPhone}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <TextField
                                    select
                                    value={country?.code}
                                    onChange={handleCountryChange}
                                    variant="standard"
                                    size="small"
                                    disabled={initialContact.hasPhone}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "0",
                                            fontSize: "0.875rem",
                                            "&:hover fieldset": { borderColor: "#d1d5db" },
                                            "&.Mui-focused fieldset": { borderColor: "#374151" },
                                        },
                                    }}
                                    InputProps={{ disableUnderline: true }}
                                >
                                    {countryData.map((c) => (
                                        <MenuItem key={c.code} value={c.code}>
                                            {c.code} (+{c.phone})
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </InputAdornment>
                        ),
                    }}
                    error={error}
                    helperText={error !== "" ? error : ""}
                    sx={{
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "0",
                            fontSize: "0.875rem",
                            "&:hover fieldset": { borderColor: "#d1d5db" },
                            "&.Mui-focused fieldset": { borderColor: "#374151" },
                        },
                    }}
                />
                {/* <input
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    // maxLength={10}
                    readOnly={initialContact.hasPhone}
                    className={`h-10 w-full border px-3 text-sm outline-none ${initialContact.hasPhone ? "bg-gray-100 cursor-not-allowed" : ""
                        }`}
                    placeholder="Enter Phone Number"
                />
                {errors.phone && (
                    <p className="text-xs text-red-500">{errors.phone}</p>
                )} */}
            </div>

            {/* Email */}
            <div className="grid gap-2">
                <label className="text-xs uppercase text-neutral-700">
                    Email Address
                </label>
                <input
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    readOnly={initialContact.hasEmail}
                    className={`h-10 w-full border px-3 text-sm outline-none ${initialContact.hasEmail ? "bg-gray-100 cursor-not-allowed" : ""
                        }`}
                    placeholder="Enter Email Address"
                />
                {errors.email && (
                    <p className="text-xs text-red-500">{errors.email}</p>
                )}
            </div>

            {/* Submit */}
            <button
                type="submit"
                disabled={auth?.isLoading}
                className="h-11 bg-neutral-900 text-white text-sm uppercase disabled:opacity-50"
            >
                {auth?.isLoading ? "Saving..." : "Save Changes"}
            </button>
        </form>
    );
}

export default PersonalDetailForm;
